import { useQuery } from '@tanstack/react-query';
import {
  FeedbackService,
  FeedbackPaginationParams,
} from '../../services/feedbackService';

// Query keys for consistent cache management
export const feedbackKeys = {
  all: ['feedback'] as const,
  lists: () => [...feedbackKeys.all, 'list'] as const,
  paginated: (params: FeedbackPaginationParams) =>
    [...feedbackKeys.all, 'paginated', params] as const,
};

/**
 * Hook for fetching paginated feedback with React Query
 * Admin-only feature for viewing all feedback across requests
 */
export const useFeedbackPaginatedQuery = (params: FeedbackPaginationParams) => {
  return useQuery({
    queryKey: feedbackKeys.paginated(params),
    queryFn: () => FeedbackService.getFeedbackPaginated(params),
    staleTime: 30 * 1000, // 30 seconds
    gcTime: 10 * 60 * 1000, // 10 minutes cache time
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    retry: false,
    networkMode: 'always',
    placeholderData: previousData => previousData,
    meta: {
      errorMessage: 'Failed to fetch feedback. Please check your connection.',
    },
  });
};

// Re-export types for convenience
export type { FeedbackItem, FeedbackPaginationParams, PaginatedFeedbackResponse } from '../../services/feedbackService';
